<template>
  <table class="table-auto w-full">
    <thead>
    <tr class="text-left border-b">
      <th class="px-4 py-2 ">Name</th>
      <th class="px-4 py-2">Address</th>
      <th class="px-4 py-2">Email</th>
      <th class="px-4 py-2">Phone number</th>
      <th class="px-4 py-2">Description</th>
      <th class="px-4 py-2">Created at</th>
      <th class="px-4 py-2">Last updated</th>
      <th class="px-4 py-2">Admin</th>
    </tr>
    </thead> 
    <tbody>
    <tr class="border-b hover:bg-gray-200" v-for="org in organizations" :key="org.id">
      <td class="px-4 py-2 hover:text-teal-500">
        <router-link :to="{name: 'organization', params: {orgId: org.id}}">{{ org.name }}
        </router-link>
      </td>
      <td class="px-4 py-2">{{ org.address }}</td>
      <td class="px-4 py-2">{{ org.email_address }}</td>
      <td class="px-4 py-2">{{ org.phone_number }}</td>
      <td class="px-4 py-2">{{ org.more_info }}</td>
      <td class="px-4 py-2">{{ org.created_at }}</td>
      <td class="px-4 py-2">{{ org.updated_at }}</td>
      <td class="px-4 py-2">
        <button v-if="org.admin_status !== 'Accepted'" @click="acceptInvitation(org.id,'Accepted')"
                class="bg-transparent hover:bg-teal-500 text-teal-500 hover:text-white py-1 px-2 border border-teal-500 hover:border-transparent rounded mr-2">
          Accept
        </button>
        <button v-if="org.admin_status !== 'Declined'" @click="acceptInvitation(org.id,'Declined')"
                class="bg-transparent hover:bg-orange-500 text-orange-500 hover:text-white py-1 px-2 border
                         border-orange-500 hover:border-transparent rounded mr-2">
          Decline
        </button>
        <button @click="acceptInvitation(org.id,'Delete')"
                class="bg-transparent hover:bg-red-500 text-red-500 hover:text-white py-1 px-2 border border-red-500 hover:border-transparent rounded mr-2">
          Delete
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import OrganizationService from "../services/organizations.service";

export default {
  name: "OrganizationsComponent",
  props: {
    adminStatus: String
  },
  data() {
    return {
      organizations: []
    }
  },
  mounted() {
    this.getOrganizations();
  },
  methods: {
    getOrganizations() {
      this.loading = true;
      this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations?admin_status=' + this.adminStatus)
          .then((result) => {
            this.organizations = result.data.data.organizations;
          }).catch(() => {
        this.errors.push("An error occurred while connecting to server")
      }).finally(() => {
        this.loading = false;
      });
    },
    acceptInvitation(orgId, status) {
      OrganizationService.updateAdminInvite(
          {
            "status": status,
            "organization_id": orgId
          }
      ).then((response) => {
        this.$root.$emit("alert_success", [response.message])
        this.getOrganizations()
      }).catch(() => {
        this.$root.$emit("alert_error", ["An error occurred while connecting to server"])
      });
    }
  }
}
</script>

<style scoped>

</style>